import { render, staticRenderFns } from "./traineePostassessmentList.vue?vue&type=template&id=be225594&scoped=true"
import script from "./traineePostassessmentList.vue?vue&type=script&lang=js"
export * from "./traineePostassessmentList.vue?vue&type=script&lang=js"
import style0 from "./traineePostassessmentList.vue?vue&type=style&index=0&id=be225594&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be225594",
  null
  
)

export default component.exports